export default __webpack_public_path__ + "static/img/dms_banner.dc90790.svg";